import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import CannedResponseChips from "./CannedResponseChips";
import { NOT_ELIGIBLE_CANNED_RESPONSES } from "./cannedReviewResponses";

export default function SetPlayerNotEligibleDialog({
  openState,
  userContext,
  onClose,
  onSetPlayerNotEligible,
}) {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");

  const handleClose = () => {
    setReason("");
    setReasonError("");
    setBtnDisabled(false);
    onClose();
  };

  const handleSave = () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      setReasonError("Please provide a reason. It will be included in the email sent to the player.");
      return;
    }
    setBtnDisabled(true);
    onSetPlayerNotEligible(userContext.row.userId, trimmed);
    setTimeout(() => {
      setBtnDisabled(false);
      setReason("");
      setReasonError("");
    }, 5 * 1000);
  };

  if (!("row" in userContext)) return <></>;

  return (
    <Dialog
      open={openState}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="form-dialog-title">
        Set {userContext.row.nickname} as Not Eligible
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: 16 }}>
          This will mark the player as Not Eligible and send them an email with your
          reason. It will also open (or continue) their eligibility appeal thread so they
          can respond from their account settings page.
        </DialogContentText>
        <CannedResponseChips
          presets={NOT_ELIGIBLE_CANNED_RESPONSES}
          value={reason}
          onToggle={({ nextValue }) => {
            setReason(nextValue);
            if (reasonError) setReasonError("");
          }}
        />
        <TextField
          label="Reason (required)"
          placeholder="Explain why this player is not eligible..."
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          variant="outlined"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (reasonError) setReasonError("");
          }}
          error={!!reasonError}
          helperText={reasonError || "This reason will be emailed to the player and shown in their account."}
          inputProps={{ maxLength: 2000 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Dismiss
        </Button>
        <Button
          disabled={btnDisabled || !reason.trim()}
          onClick={handleSave}
          color="primary"
          variant="contained"
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
